module.exports = __webpack_public_path__ + "static/img/top-right-bg.7b24097.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/top-right-bg.png
// module id = ee+H
// module chunks = 0